<script setup lang="ts">
import { fetchGetSystemSetting } from '@/service/api';
import FApi from "@/service/api/manage-system/modules/system-setting/types";


defineOptions({
  name: 'GlobalLogo'
});

interface Props {
  /** Whether to show the title */
  showTitle?: boolean;
}

withDefaults(defineProps<Props>(), {
  showTitle: true
});

const model = reactive<FApi.SystemSetting>({})
const fetchGetSystemSettingFn = async () => {
  try {
    const { data, error } = await fetchGetSystemSetting();
    if (!error) {
      Object.assign(model, data)
    }
  } catch (error) {
    console.log(error);

  }
}

onMounted(() => {
  fetchGetSystemSettingFn()
})
</script>

<template>
  <RouterLink to="/" class="w-full flex-center nowrap-hidden" style="">
    <SystemLogo class="text-32px text-primary" style="width: 33px;" :logo="model.companyLogo"/>
    <!-- <h2  class="pl-8px text-16px text-primary font-bold transition duration-300 ease-in-out">
      {{ model.tenantSysName }}
    </h2> -->
  </RouterLink>
</template>

<style scoped></style>
